<template>
	<footer class="footer">
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-6">
					2022 © Krasp. {{ $t("message") }}
				</div>
				<div class="col-sm-6">
					<div class="text-sm-end d-none d-sm-block">
						Разработал <a href="https://bylex.info" target="_blank" class="text-reset">Алексей (lexinzector) Михалёв</a>
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<style lang="css" scoped>

</style>

<script>
import lib from '@/lib';

export default {
	name: 'Footer',
	mixins: lib.mixins,
	props: {},
	data: () => ({
		
	}),
	methods: {
		
	},
	computed: {},
}
</script>